export default __webpack_public_path__ + "static/media/header-x1.b6f067c6.png";